import modifyTemplate from '#shared/util/modifyTemplate.js';

import defaultWebProduct from '#themes/default/web/components/product/product.js';

import cButton from '#themes/avast/web/components/button/button.js';
import cProductInstructions from '#themes/avast/web/components/productInstructions/productInstructions.js';
import cQuantity from '#themes/avast/web/components/quantity/quantity.js';
import cSelect from '#themes/avast/web/components/select/select.js';
import cSkeleton from '#themes/avast/web/components/skeleton/skeleton.js';
import cSvg from '#themes/avast/web/components/svg/svg.js';
import cTooltip from '#themes/avast/web/components/tooltip/tooltip.js';

import productInstructionsTemplate from './html/productInstructions.html' with { type: 'html' };

const template = modifyTemplate(defaultWebProduct.template, [{
	query: '.product_instructions',
	position: 'after',
	content: productInstructionsTemplate
}]);

export default {
	components: {
		cButton,
		cProductInstructions,
		cQuantity,
		cSelect,
		cSkeleton,
		cSvg,
		cTooltip
	},
	extends: defaultWebProduct,
	template
};
